import React from "react";
import { useIntl } from "react-intl";
import { IGroupVisibility } from "~/types/types";
import NewLinkTab from "~/components/profile/NewLinkTab";
import ProfileNavbar from "~/components/profile/ProfileNavbar";
import { IGroupNavbarProps } from "~/components/group/IGroupProps";

export default function GroupNavbar({ group, tab }: IGroupNavbarProps) {
  const intl = useIntl();

  if (
    !group.viewerIsMember &&
    group.feedCount === 0 &&
    group.projectsCount === 0 &&
    group.productsCount === 0 &&
    group.newsworthy.length === 0 &&
    group.membersCount <= 6
  ) {
    return null;
  }

  return (
    <ProfileNavbar>
      {(group.feedCount > 0 || group.viewerIsMember) && (
        <NewLinkTab
          href="/groups/[groupSlug]"
          as={`/groups/${group.slug}`}
          title={intl.formatMessage({
            defaultMessage: "Activity",
            id: "ZmlNQ3",
          })}
          count={group.feedCount}
          active={tab === "connect"}
          dataIntercomTarget="Group Activity Tab"
        />
      )}

      {(group.projectsCount > 0 || group.viewerIsMember) && (
        <NewLinkTab
          href="/groups/[groupSlug]?content=projects"
          as={`/groups/${group.slug}?content=projects`}
          title={
            group.visibility === IGroupVisibility.Public
              ? intl.formatMessage({
                  defaultMessage: "Topics",
                  id: "kc79d3",
                })
              : intl.formatMessage({
                  defaultMessage: "Projects",
                  id: "UxTJRa",
                })
          }
          count={group.projectsCount}
          active={tab === "projects"}
          dataIntercomTarget="Group Projects Tab"
        />
      )}

      {(group.productsCount > 0 || group.viewerIsMember) && (
        <NewLinkTab
          href="/groups/[groupSlug]?content=products"
          as={`/groups/${group.slug}?content=products`}
          title={intl.formatMessage({
            defaultMessage: "Products",
            id: "7NFfmz",
          })}
          count={group.productsCount}
          active={tab === "products"}
          dataIntercomTarget="Group Products Tab"
        />
      )}

      {(group.newsworthy.length > 0 || group.viewerIsMember) && (
        <NewLinkTab
          href="/groups/[groupSlug]?content=newsworthy"
          as={`/groups/${group.slug}?content=newsworthy`}
          title={intl.formatMessage({
            defaultMessage: "Newsworthy",
            id: "JhItYg",
          })}
          count={group.newsworthy.length}
          active={tab === "newsworthy"}
          dataIntercomTarget="Group Newsworthy Tab"
        />
      )}

      {group.membersCount > 6 && (
        <NewLinkTab
          href="/groups/[groupSlug]?content=members"
          as={`/groups/${group.slug}?content=members`}
          title={intl.formatMessage({
            defaultMessage: "Members",
            id: "+a+2ug",
          })}
          count={group.membersCount}
          active={tab === "members"}
          dataIntercomTarget="Group Members Tab"
        />
      )}
    </ProfileNavbar>
  );
}
